<h2 class="home-title" [innerHTML]="_title | safe: 'html'">Te brindamos lo mejor en soluciones digitales</h2>
<div class="home-description" [innerHTML]="_description | safe: 'html'"></div>
<div class="home-puzzle">
  <app-solution *ngFor="let s of solutions" [solution]="s" [ngClass]="getClass(s.vacio, s.size, s.imagen)"
    [style.--imagen]="(s.imagen !== null ? ('url(' + (s.imagen.id | directus) + ')') : '')"
    [style.--data-position]="s.posicion"></app-solution>
</div>